module.exports = __webpack_public_path__ + "assets/search.51048490.svg";